module.exports = __webpack_public_path__ + "static/media/zurich.eb0a3ca5.svg";